import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../lib/api'
import { useAuth } from '../lib/auth'

export function DiscoverPage() {
  const { token, refresh } = useAuth()
  const nav = useNavigate()
  const [templates, setTemplates] = useState<any[]>([])
  const [busy, setBusy] = useState<string | null>(null)

  useEffect(() => {
    api<any>('/api/catalog', { token })
      .then((c) => setTemplates(c.templates || []))
      .catch(() => {
        setTemplates([
          {
            id: 'mma-fight-card',
            title: 'MMA / Boxing fight card',
            blurb: 'Full UFC-style card.',
            cover: '/assets/mma/server-card-cover/desktop-cover.png',
          },
        ])
      })
  }, [token])

  async function create(template: string, title: string) {
    setBusy(template)
    try {
      const res = await api<{ competition: { id: string } }>('/api/competitions', {
        method: 'POST',
        token,
        body: { title, template },
        idempotencyKey: `disc-${template}-${Date.now()}`,
      })
      await refresh()
      nav(`/events/${res.competition.id}`)
    } finally {
      setBusy(null)
    }
  }

  return (
    <div className="stack">
      <section
        className="hero-fight"
        style={{ minHeight: 160 }}
      >
        <div className="bg" style={{ backgroundImage: 'url(/assets/mma/hero-backdrop/tablet.png)' }} />
        <div className="veil" />
        <div className="content">
          <div className="eyebrow">Catalog</div>
          <h1>Release 1 event templates</h1>
          <p className="muted" style={{ color: '#cbd5e1' }}>
            Fully wired end-to-end — not demo stubs. MMA opens the UFC 329 sourced card.
          </p>
        </div>
      </section>

      <div className="grid three">
        {templates.map((t) => (
          <div key={t.id} className="template-card">
            <div className="cover" style={{ backgroundImage: `url(${t.cover})` }} />
            <div className="body">
              <h3>{t.title}</h3>
              <p>{t.blurb}</p>
              <button className="btn" disabled={busy === t.id} onClick={() => create(t.id, t.title)}>
                {busy === t.id ? 'Creating…' : 'Create event'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
